import Swal from "sweetalert2";

/**
 * Show an error alert.
 */
export function showError(text, title = "Error") {
  return Swal.fire({
    icon: "error",
    title,
    text,
    confirmButtonColor: "#0d6efd",
  });
}

/**
 * Show a success alert.
 */
export function showSuccess(text, title = "Success") {
  return Swal.fire({
    icon: "success",
    title,
    text,
    confirmButtonColor: "#0d6efd",
  });
}

/**
 * Show a warning alert.
 */
export function showWarning(text, title = "Warning") {
  return Swal.fire({
    icon: "warning",
    title,
    text,
    confirmButtonColor: "#0d6efd",
  });
}

/**
 * Show a confirmation dialog. Returns a Promise that resolves to true if confirmed, false otherwise.
 */
export function confirmDialog({ title = "Are you sure?", text, confirmButtonText = "Yes", cancelButtonText = "Cancel" }) {
  return Swal.fire({
    title,
    text,
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#0d6efd",
    cancelButtonColor: "#6c757d",
    confirmButtonText,
    cancelButtonText,
  }).then((result) => !!result.isConfirmed);
}
